const SERVICES = [
  { t: "Ambulatory Rides", d: "For walkers and canes; curb-to-curb or assisted." },
  { t: "Wheelchair Transport", d: "Ramps, securements, and trained assistance." },
  { t: "Stretcher Transport", d: "Safe non-emergency stretcher transfers." },
  { t: "Dialysis & Chemo", d: "Reliable recurring schedules and returns." },
  { t: "Hospital Discharge", d: "Prompt pickup with home-entry assistance." },
  { t: "Airport Ride", d: "" },
];

export default function ServiceCards() {
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="fw-bold h3">Services</h2>
        <p className="text-secondary">Door-to-door and door-through-door transportation.</p>
        <div className="row g-4 mt-1">
          {SERVICES.map((s) => (
            <div className="col-12 col-md-6 col-lg-4" key={s.t}>
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{s.t}</h5>
                  <p className="card-text text-secondary">{s.d}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
